// extracted by mini-css-extract-plugin
export default {"icon":"chatInputForm_icon__lSgST","messageInput":"chatInputForm_messageInput__Srktx","messageInputDisabled":"chatInputForm_messageInputDisabled__U5Ece"};